import { convertModeToKey } from './convertModeToKey';
import fixUpHotkeyCommand from 'owa-hotkeys/lib/utils/fixupHotkeyCommand';
import type { HotkeyCommand } from 'owa-hotkeys/lib/types/HotkeyCommand';
import { convertHotkeyStringToReadableText } from './convertHotkeyStringToReadableText';
import getKeyboardShortcutsMode from 'owa-hotkeys/lib/utils/getKeyboardShortcutsMode';

export function convertHotkeyToReadableText(command: HotkeyCommand) {
    // Get the name of the keyboard shortcuts style the user has enabled.
    const keyboardShortcutsMode = getKeyboardShortcutsMode();
    const modeKey = convertModeToKey(keyboardShortcutsMode);
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7053 (14,26): Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'HotkeyCommand | Hotkeys'.
    // @ts-expect-error
    const fixedCommand = fixUpHotkeyCommand(command)[modeKey];

    return fixedCommand ? convertHotkeyStringToReadableText(fixedCommand) : undefined;
}
